// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"237":"d846fff3","2766":"144e2d4d","7420":"81c1792e","8340":"bd3735b8"}[chunkId] + ".css";
};